import { render, staticRenderFns } from "./TransactionModal.vue?vue&type=template&id=021eb6a2&scoped=true&"
import script from "./TransactionModal.vue?vue&type=script&lang=ts&"
export * from "./TransactionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021eb6a2",
  null
  
)

export default component.exports